export const SummaryCard = ({ label, value, helperText, accent = "zinc", testId }) => {
  const accentClasses = {
    zinc: "bg-zinc-900 text-white",
    blue: "bg-blue-600 text-white",
    orange: "bg-orange-500 text-white",
    green: "bg-green-600 text-white",
    purple: "bg-purple-600 text-white",
  };

  return (
    <div className="panel-surface flex h-full flex-col justify-between gap-4 px-5 py-5" data-testid={testId}>
      <div className="flex items-center justify-between gap-4">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-zinc-500">{label}</p>
        <span className={`rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] ${accentClasses[accent] || accentClasses.zinc}`}>
          Live
        </span>
      </div>

      <div>
        <p className="text-3xl font-semibold text-zinc-900" data-testid={`${testId}-value`}>{value}</p>
        {helperText ? null : null}
      </div>
    </div>
  );
};